module.exports = __webpack_public_path__ + "static/media/icon_tabulation_r.1b3fb42d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_tabulation_r.svg
// module id = 341
// module chunks = 0